import React, { useState } from 'react';
import './Reports.css';
import Modal from './Modal';
import pdfFile from '../Assets/Parity empowerment initiative uganda (1).pdf';
import pptxFile from '../Assets/Economic Justice, Intersectional Wellbeing, and Decolonialfinal.pptx';

const ReportCard = ({ year, title, description, onDownloadClick, link, fileType = "PDF" }) => (
  <div className="report-card">
    <div className="report-year">{year}</div>
    <h3>{title}</h3>
    <p>{description}</p>
    {link && link !== "#" ? (
      <a href={link} className="download-btn" target="_blank" rel="noopener noreferrer" download>
        Download {fileType}
      </a>
    ) : (
      <button className="download-btn" onClick={onDownloadClick}>
        Download {fileType}
      </button>
    )}
  </div>
);

const Reports = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDownloadClick = () => {
    setIsModalOpen(true);
  };

  const annualReports = [
    {
      title: "Annual Parity Empowerment Initiative 2025 Report",
      description: "A comprehensive overview of our activities, achievements, and impact on marginalized communities in Uganda for the year 2025.",
      link: pdfFile
    },
    {
      title: "Economic Justice, Intersectional Wellbeing, and Decolonial",
      description: "A presentation exploring economic justice, intersectional wellbeing, and decolonial perspectives in community empowerment.",
      link: pptxFile,
      fileType: "PPTX"
    },
    {
      title: "Annual Impact Report",
      description: "Detailed analysis of our programs, financial sustainability initiatives, and community engagement in 2024.",
      link: "#"
    },
    {
        title: "Annual Impact Report",
        description: "Highlights of our key milestones and the growth of our empowerment initiatives during 2023.",
        link: "#"
      }
  ];

  const financialReports = [
    {
      title: "Financial Statements",
      description: "Audited financial statements and transparency report for the fiscal year ending 2025.",
      link: "#"
    },
    {
      title: "Financial Statements",
      description: "Comprehensive financial report detailing funding sources and allocation of resources.",
      link: "#"
    }
  ];

  return (
    <div className="reports-container">
      <section className="reports-hero">
        <h1>Reports & Publications</h1>
        <p>Transparency and accountability are at the core of our operations. Explore our annual reports and financial statements to see how we are making a difference.</p>
      </section>

      <section className="reports-section">
        <h2>Reports</h2>
        <div className="reports-grid">
          {annualReports.map((report, index) => (
            <ReportCard key={index} {...report} onDownloadClick={handleDownloadClick} />
          ))}
        </div>
      </section>

      <section className="reports-section">
        <h2>Financial Reports</h2>
        <div className="reports-grid">
          {financialReports.map((report, index) => (
            <ReportCard key={index} {...report} onDownloadClick={handleDownloadClick} />
          ))}
        </div>
      </section>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2>Coming Soon</h2>
        <p>The report will be available for download soon. Stay tuned!</p>
      </Modal>
    </div>
  );
};

export default Reports;